export const useViewModel = (props) => {
    return props;
};
